import React from 'react';
import { LockIcon, TrophyIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { offerItems, offerPricing } from '../data/content';
export function OfferSection() {
  return <section id="oferta" className="w-full bg-night-deep px-5 py-12" aria-labelledby="oferta-titulo" data-id="element-114" data-mp="8lls04tbrpex">
      <div className="mx-auto max-w-xl overflow-hidden rounded-2xl border border-night-line bg-night-soft" data-id="element-115" data-mp="id8ckrrjz0uc">
        <p className="bg-gold py-3 text-center font-display text-[11px] font-bold uppercase tracking-[0.22em] text-night-deep" data-id="element-116" data-mp="mejt87sg8bqe">
          ⚜ Oferta exclusiva por tiempo limitado ⚜
        </p>

        <div className="px-5 py-8 md:px-8" data-id="element-117" data-mp="wczkcarh7kzw">
          <h2 id="oferta-titulo" className="text-center font-display text-xl font-bold text-cream md:text-2xl" data-id="element-118" data-mp="wby65xf5yidy">
            Todo lo que recibirás hoy: <span className="text-gold" data-id="element-119" data-mp="2t7m9yepgr1bl">gratis</span>
          </h2>

          <CountdownTimer data-id="element-120" data-mp="2y55qjl9mvq6p" />

          <ul className="mt-8 space-y-3" data-id="element-121" data-mp="2y6gt5hrcerw8">
            {offerItems.map(item => <li key={item.label} className="flex items-center gap-3 rounded-lg border border-night-line bg-night-card px-4 py-3" data-id="element-122" data-mp="12otgzl4yljkl">
                <span aria-hidden="true" className="text-lg" data-id="element-123" data-mp="syibvv9jh4c4">
                  {item.emoji}
                </span>
                <span className="min-w-0 flex-1 text-sm leading-snug text-cream" data-id="element-124" data-mp="oxyf4ssvo2qi">{item.label}</span>
                <span className="shrink-0 text-xs text-red-400 line-through" data-id="element-125" data-mp="1lll5c8zcyovi">{item.price}</span>
                <span className={`shrink-0 rounded px-2 py-1 text-[10px] font-bold uppercase tracking-wide ${item.badge ? 'bg-gold/15 text-gold' : 'bg-emerald-500/15 text-emerald-400'}`} data-id="element-126" data-mp="1go2uue5p01le">
                  {item.badge ?? 'Gratis'}
                </span>
              </li>)}
          </ul>

          <div className="mt-8 border-t border-night-line pt-7 text-center" data-id="element-127" data-mp="3sbstu274apcq">
            <p className="text-xs text-cream-dim" data-id="element-128" data-mp="3tthq0vop768d">
              Valor total de todo lo incluido: <span className="text-gold" data-id="element-129" data-mp="2ng946i1xiet">{offerPricing.totalValue}</span>
            </p>
            <p className="mt-5 font-display text-[10px] font-semibold uppercase tracking-[0.25em] text-cream-dim" data-id="element-130" data-mp="3ktbevggh2icd">De</p>
            <p className="mt-1 font-display text-3xl font-bold text-red-400 line-through" data-id="element-131" data-mp="3ouddpw6h8sdt">
              {offerPricing.regularPrice}
            </p>
            <p className="mt-3 text-sm text-cream-dim" data-id="element-132" data-mp="3b270oiymf1il">Por solo</p>
            <p className="mt-1 font-display text-4xl font-bold text-emerald-400 md:text-5xl" data-id="element-133" data-mp="3fv9ums7b8czb">
              {offerPricing.finalPrice}
            </p>
            <p className="mt-4 inline-block rounded-full border border-emerald-500/40 bg-emerald-500/10 px-4 py-1.5 text-xs font-semibold text-emerald-400" data-id="element-134" data-mp="313he4cvs4sw0">
              🔥 ¡Ahorras {offerPricing.savings}!
            </p>

            <CtaButton href="#oferta" className="mt-7 w-full" data-id="element-135" data-mp="2x3gywq0uwdnw">
              Quiero acceder a los mapas 3D
            </CtaButton>

            <p className="mt-5 flex items-center justify-center gap-2 text-xs text-cream-dim" data-id="element-136" data-mp="2diqa3lil54xl">
              <span aria-hidden="true" className="h-2 w-2 rounded-full bg-emerald-400" data-id="element-137" data-mp="28jvq4g8vtabw" />
              🔥 <strong className="font-semibold text-cream" data-id="element-138" data-mp="2mjofo88o9kia">{offerPricing.viewers} personas</strong> están viendo esta
              oferta ahora mismo
            </p>

            <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-cream-dim" data-id="element-139" data-mp="2wgt1u82ipfz3">
              <li className="flex items-center gap-1.5" data-id="element-140" data-mp="2ri84cgenhaec">
                <LockIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-141" data-mp="2rflvmdg0wouj" /> Pago seguro
              </li>
              <li className="flex items-center gap-1.5" data-id="element-142" data-mp="368fbw134d909">
                <TrophyIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-143" data-mp="318uc5og4kwmh" /> Satisfacción garantizada
              </li>
              <li className="flex items-center gap-1.5" data-id="element-144" data-mp="3f57v720b5632">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-145" data-mp="3a990yxsastuq" /> Privacidad protegida
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}